/**
 * Threshold for showing tooltips on truncated text.
 * If a label exceeds this length, a tooltip will be shown on hover.
 */
export const TRUNCATE_THRESHOLD = 25;
